<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni

  This file BuyButton.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  BuyButton.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: BuyButton 
 Created by keni.
 with: IntelliJ IDEA
 Date: 12/09/2018
 Time: 16:18
------------------------------------------------------------------------------->
<template>
    <div data-buy-button>

        <vue-btn v-if="!sold_out"
                 @buttonClick="$emit('buttonClick',ticket_id)"

                 class="btn-info"
                 :icon="(!event_expired)?'add_shopping_cart':null"
                 :class="[
                 cls,
                 {
                                        'btn-secondary':can_buy_now && !limited,
                                        'btn-primary': !can_buy_now && !limited,
                                        'btn-warning': limited,
                                        'disabled': event_expired
                                        }
                 ]"
        >
            <template slot="content">
                <span v-if="limited" data-v-fccf592e="" class="limited-available badge badge-warning position-absolute">Almost gone</span>

                <!--show button price-->

                <div data-element="button-price-wrapper">
                    <!--ended event-->
                    <div
                            v-if="event_expired"
                            class="mx-auto"
                    >Ended
                    </div>
                    <!--limited-->
                    <!--<div v-else-if="limited">-->
                        <!--<div class="text-body fs-7 lh-7"-->
                             <!--v-html="formatMoney(ticket_price)"-->
                        <!--&gt;</div>-->
                        <!--&lt;!&ndash;<div class="text-body lh-3 fs-3"&ndash;&gt;-->
                        <!--&lt;!&ndash;&gt;Limited&ndash;&gt;-->
                        <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--</div>-->
                    <!--no restrictions-->
                    <div
                            class="text-body fs-7 lh-7"
                            v-else
                            v-html="formatMoney(ticket_price)"
                    ></div>
                </div>
            </template>
        </vue-btn>
        <vue-btn v-else
                 class="btn-outline-primary disabled"
                 icon="not_interested"
        >
            <template slot="content">
                <span class="text-body fs-4">sold out</span>
            </template>
        </vue-btn>
    </div>
</template>

<script>
	import {format as formatMoney} from '../../helpers/money';

	Vue.component('vue-btn', require('./Buttons.vue'));
	export default {
		name: "buy-button",
		components: {},
		props: [
			'cls',
			'ticket',
			'can_buy_now',
			'event_expired',
			'target_id',
			'limited',
			'sold_out',
			'ticket_price',
			'ticket_events',
			'add_ticket_url',
			'ticket_id',
		],
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {
			formatMoney(price) {
				return formatMoney(price, {
					code: $('body').data('currency')
				});
			},
		},
		watch: {},
		computed: {}
	}
</script>

<style scoped>
.limited-available{
    top:-10px;
}
</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/buttons/BuyButton.vue